module.exports = __webpack_public_path__ + "static/media/15.9f6af9b5.jpg";